/**
 * @generated SignedSource<<821e9a0171d0f41dffcc22e0b0cff8dd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type PublishState = "ARCHIVED" | "DELETED" | "DRAFT" | "PUBLISHED" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ShortcutButton_node$data = {
  readonly __typename: string;
  readonly content?: {
    readonly id?: string;
    readonly mimeType?: string;
    readonly url?: URIString;
  };
  readonly coverImage?: {
    readonly url: URIString;
  } | null;
  readonly id: string;
  readonly name?: string;
  readonly ownershipEvent?: {
    readonly id: string;
  } | null;
  readonly ownershipFolders?: {
    readonly nodes: ReadonlyArray<{
      readonly id: string;
    }>;
  };
  readonly ownershipSpace?: {
    readonly canModifySpaceShortcuts: {
      readonly value: boolean;
    };
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"ManageSpaceShortcutModal_space">;
  };
  readonly publishState?: PublishState;
  readonly " $fragmentType": "ShortcutButton_node";
};
export type ShortcutButton_node$key = {
  readonly " $data"?: ShortcutButton_node$data;
  readonly " $fragmentSpreads": FragmentRefs<"ShortcutButton_node">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  (v0/*: any*/)
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "publishState",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ShortcutButton_node",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    (v0/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Space",
          "kind": "LinkedField",
          "name": "ownershipSpace",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "AuthorizationResult",
              "kind": "LinkedField",
              "name": "canModifySpaceShortcuts",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "value",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "ManageSpaceShortcutModal_space"
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Event",
          "kind": "LinkedField",
          "name": "ownershipEvent",
          "plural": false,
          "selections": (v1/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "last",
              "value": 1
            }
          ],
          "concreteType": "FolderConnection",
          "kind": "LinkedField",
          "name": "ownershipFolders",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Folder",
              "kind": "LinkedField",
              "name": "nodes",
              "plural": true,
              "selections": (v1/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": "ownershipFolders(last:1)"
        }
      ],
      "type": "HasOwnerPermissionsInterface",
      "abstractKey": "__isHasOwnerPermissionsInterface"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v2/*: any*/),
        (v3/*: any*/)
      ],
      "type": "FolderNodeInterface",
      "abstractKey": "__isFolderNodeInterface"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "content",
          "plural": false,
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": [
                (v0/*: any*/),
                (v4/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "mimeType",
                  "storageKey": null
                }
              ],
              "type": "File",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "FolderItem",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v2/*: any*/),
        (v3/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "CoverImage",
          "kind": "LinkedField",
          "name": "coverImage",
          "plural": false,
          "selections": [
            (v4/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "type": "Event",
      "abstractKey": null
    }
  ],
  "type": "Node",
  "abstractKey": "__isNode"
};
})();

(node as any).hash = "acc336f325f51cff7195810e38fcac56";

export default node;
